// 仓库
const warehouse = [
  {
    path: '/warehouse',
    name: 'warehousePage',
    meta: { tag: '仓库管理' },
    component: () => import('@/pages/WarehousePage')
  },
  {
    path: '/warehouse-log',
    name: 'warehouseLogPage',
    meta: { tag: '出入库单' },
    component: () => import('@/pages/WarehouseLogPage')
  },
  {
    path: '/warehouse-transfer-log',
    name: 'warehouseTransferLogPage',
    meta: { tag: '调拨单' },
    component: () => import('@/pages/WarehouseTransferLogPage')
  },
  {
    path: '/warehouse-assemble-log',
    name: 'warehouseAssembleLogPage',
    meta: { tag: '拆卸单' },
    component: () => import('@/pages/WarehouseAssembleLogPage')
  },
  {
    path: '/warehouse-materials',
    name: 'WarehouseMaterials',
    meta: { tag: '库存清单' },
    component: () => import('@/pages/WarehouseMaterials')
  },
  {
    path: '/warehouse-material-checks',
    name: 'warehouseMaterialChecks',
    meta: { tag: '库存盘点' },
    component: () => import('@/pages/WarehouseMaterialCheck')
  },
  {
    path: '/warehouse-log-type',
    name: 'warehouseLogTypePage',
    meta: { tag: '单据类型配置' },
    component: () => import('@/pages/WarehouseLogTypePage')
  },
  {
    path: '/warehouse-channel',
    name: 'warehouseChannelPage',
    meta: { tag: '仓库渠道配置' },
    component: () => import('@/pages/WarehouseChannelPage')
  },
  {
    path: '/warehouse-transfer',
    name: 'warehouseTransferPage',
    meta: { tag: '中转站' },
    component: () => import('@/pages/WarehouseTransferPage/index.vue')
  }
]

export default warehouse
